export enum NotificationSeverity {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
}

type NotificationAction = (key: React.ReactText) => void;

export interface Notification {
  identifier?: string;
  text: string;
  severity: NotificationSeverity;
  action?: NotificationAction;
  actionContext?: React.ReactNode;
  withClose?: boolean;
  autoHide?: boolean;
}
